import {
  Question,
  getQuestions,
  saveQuestion,
  deleteQuestion
} from "@/api/minutes-api";
import QuestionFormData from "@/api/models/QuestionFormData";

export default class MinuteTypeService {
  /**
   * 質問を編集する
   */
  async edit(id: string, projectId: string): Promise<Question> {
    const minutes = await getQuestions(projectId);
    const m = minutes.find(m => String(m.id) === String(id));
    if (!m) {
      throw new Error("question is not found.");
    }
    m.answers.forEach(a => {
      this.appendAnswerOptionTo(a);
    });
    return m;
  }

  /**
   * 質問を保存する
   */
  async save(question: Question): Promise<void> {
    // 保存する前に余計な選択肢は削除する
    question.answers.forEach(a => {
      if (a.type === "0") {
        a.options = [];
      }
      a.options = a.options.filter(o => o.text);
    });
    const data = QuestionFormData(question);
    await saveQuestion(data);
  }

  /**
   * 質問を削除する
   */
  async destroy(id: string): Promise<void> {
    await deleteQuestion(id);
  }

  /**
   * 項目を追加する
   */
  appendAnswerTo(question: Question): void {
    // 最後のanswerの回答タイプをコピーする
    const answer = question.answers.slice(-1)[0];
    const type = answer ? answer.type : "1";
    question.answers.push({
      id: 0,
      type,
      question: "",
      options: [this.newOption()]
    });
  }

  /**
   * 記述以外で選択肢がない場合は仮の選択肢を用意する
   */
  changeAnswerType(answer: any): void {
    if (answer.options.length > 0) return;
    this.appendAnswerOptionTo(answer);
  }

  /**
   * 項目を削除する
   */
  removeAnswerFrom(question: Question, answerIndex: number): void {
    if (!this.hasManyAnswers(question)) return;
    question.answers.splice(answerIndex, 1);
  }

  /**
   * 項目に選択肢を追加する
   */
  appendAnswerOptionTo(answer: any): void {
    answer.options.push(this.newOption());
  }

  /**
   * 項目から選択肢を削除する
   */
  removeAnswerOptionFrom(answer: any, optionIndex: number): void {
    answer.options.splice(optionIndex, 1);
  }

  private newOption() {
    return { id: 0, text: "" };
  }

  /**
   * 項目を2つ以上持っているかどうか
   */
  private hasManyAnswers(question: Question): boolean {
    return question.answers.length > 1;
  }
}
